module.exports = __webpack_public_path__ + "icon5.svg?3197898e10b055878d9b3e3133c31cb4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_svg/icon5.svg
// module id = 84
// module chunks = 0